"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var VisaLogo_png_1 = require("../images/VisaLogo.png");
var VisaLogoMulti = function (_a) {
    var className = _a.className;
    return <img src={VisaLogo_png_1.default} className={className}/>;
};
exports.default = VisaLogoMulti;
